var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Prop, Component, html } from '@sick-davinci/ce-decorators';
import { style } from './Option.style';
/**
 * A `davinci-option` is a data element for controls that allowed slotted data like `davinci-drop-down`
 * @example
 * ```html
 * <davinci-option value="1">Select me</davinci-option>
 * ```
 *
 * @slot {*} content of the option
 */

export let Option = (_dec = Component({
  tag: 'davinci-option',
  style: [style]
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", String), _dec5 = Prop(), _dec6 = Reflect.metadata("design:type", Boolean), _dec7 = Prop(), _dec8 = Reflect.metadata("design:type", Boolean), _dec(_class = _dec2(_class = (_class2 = class Option extends CustomElement {
  constructor() {
    super(); // Fix DAVIBE-620: empty string is not correctly initialized by ce-decorators

    this._internalValue = undefined;
    this._initialized = false;

    _initializerDefineProperty(this, "selected", _descriptor, this);

    _initializerDefineProperty(this, "disabled", _descriptor2, this);

    if (this.value === '') {
      this._internalValue = '';
    }
  }
  /**
   * Specifies the value of the option
   */


  get value() {
    if (!this._initialized) {
      // Fix DAVIBE-620: needed so we get the real value / internalValue
      return this._internalValue;
    }

    if (this._internalValue !== undefined) {
      return this._internalValue;
    } else {
      return this.textContent.trim();
    }
  }

  set value(value) {
    this._initialized = true;
    this._internalValue = value;
  }
  /**
   * Specifies that the option should be highlighted.
   */


  render() {
    return html`<slot></slot>`;
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "value", [_dec3, _dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selected", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec7, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class) || _class);
